var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.756,
    viewBox: "0 0 18 15.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-justify",
    transform: "translate(-2.2 -5.326)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1038",
    "data-name": "Line 1038",
    d: "M16.729.8H-.329C-.589.8-.8.442-.8,0s.211-.8.471-.8H16.729c.26,0,.471.358.471.8S16.989.8,16.729.8Z",
    transform: "translate(3 10.596)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1039",
    "data-name": "Line 1039",
    d: "M16.729.8H-.329C-.589.8-.8.442-.8,0s.211-.8.471-.8H16.729c.26,0,.471.358.471.8S16.989.8,16.729.8Z",
    transform: "translate(3 6.126)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1040",
    "data-name": "Line 1040",
    d: "M16.729.8H-.329C-.589.8-.8.442-.8,0s.211-.8.471-.8H16.729c.26,0,.471.358.471.8S16.989.8,16.729.8Z",
    transform: "translate(3 15.066)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1041",
    "data-name": "Line 1041",
    d: "M16.729.8H-.329C-.589.8-.8.442-.8,0s.211-.8.471-.8H16.729c.26,0,.471.358.471.8S16.989.8,16.729.8Z",
    transform: "translate(3 20.282)",
    fill: "#a5a5a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignicon);
export default __webpack_public_path__ + "static/media/Alignicon.aedfa68f2a7d9918a460cac706d14b76.svg";
export { ForwardRef as ReactComponent };